export const safeReturnPath = (value, fallback = '/') => {
    if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) {
        return fallback;
    }
    return value;
};
